import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "tray"];
import React, { useContext } from 'react';
import { Menu } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import { NavigationContext } from '../../Navigation.context';
import './Container.css';
var defaultProps = {
  className: '',
  tray: false
};
export default function Container(_ref) {
  var children = _ref.children,
    className = _ref.className,
    tray = _ref.tray,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(NavigationContext),
    toggled = _useContext.toggled;
  var _useSemanticUiProps = useSemanticUiProps(),
    getMenuProps = _useSemanticUiProps.getMenuProps;
  if (tray && !toggled) {
    return null;
  }
  var menuProps = getMenuProps(props);
  var finalClassName = classNames(_defineProperty({
    container: true,
    tray: tray
  }, className, !!className));
  return /*#__PURE__*/React.createElement(Menu, _extends({
    borderless: true,
    className: finalClassName
  }, menuProps), children);
}
Container.defaultProps = defaultProps;